import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ExpandedSecondary.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
	withAspectRation?: boolean
}

const ExpandedSecondaryContent = (props: Props) => {
	const element = props.data
	return (
		<>
			{element.preview && (
				<NewResponsiveImage
					containerClassName={styles.imageBox}
					imageClassName={styles.imageClassName}
					loading={"eager"}
					style={{
						aspectRatio: props.withAspectRation ? "16/9" : "auto",
					}}
					{...element.preview}
					alt={element.title ?? element.preview?.alt}
				/>
			)}
			{element.content && (
				<Typography
					className={styles.description}
					content={element.content}
					size={Size.L}
					variant={Variant.Description}
					noPadding
				/>
			)}
			<ButtonContainer>
				<ButtonSwitcher buttonsList={element} />
			</ButtonContainer>
		</>
	)
}

export default ExpandedSecondaryContent
